import { Button, Card } from "antd";
import { useNavigate } from "react-router-dom";
import FormData from "./SubCategoryForm";
import { useEffect } from "react";
import usePermissions from "../../../hooks/permissions";
import useAuth from "../../../hooks/useAuth";
import { SideBarIds } from "../../../utils/constants";
import { showWarning } from "../../../helpers/toast";

const SubCategoryForm = () => {
  const user = useAuth();
  const navigate = useNavigate();
  const permissions = usePermissions();
  const url = window.location.pathname;
  const path = url.includes("add");

  useEffect(() => {
    if (user?.role !== 1) {
      if (permissions) {
        let idx = -1;
        idx = permissions?.findIndex(
          (ele) => ele?.module?.id === SideBarIds.subCategories
        );
        if (idx > -1) {
          if (
            (!permissions[idx]?.is_add && path) ||
            (!permissions[idx]?.is_edit && !path)
          ) {
            showWarning("You are not authorized to access this page");
            navigate(-1);
          }
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions, user]);

  return (
    <div className="module-container">
      <Card>
        <div className="detail-module-card">
          <h2>{!path ? "Edit " : "Add "}Sub-Category</h2>
          <Button
            className="back-btn-container"
            type="primary"
            // htmlType="submit"
            onClick={() => {
              navigate("/manage-subcategories", { replace: true });
            }}
          >
            Back
          </Button>
        </div>
        <FormData path={!path} />
      </Card>
    </div>
  );
};

export default SubCategoryForm;
